import { render, staticRenderFns } from "./MasterPartSummary.vue?vue&type=template&id=196b1721&"
import script from "./MasterPartSummary.vue?vue&type=script&lang=ts&"
export * from "./MasterPartSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports